"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetectProvider = exports.DetectContext = void 0;
var React = require("react");
var DeviceDetect_1 = require("./DeviceDetect");
exports.DetectContext = React.createContext({
    userAgent: '',
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    setUserAgent: function (val) {
        return;
    },
    isMobileDevice: function () {
        return false;
    },
    isTabletDevice: function () {
        return false;
    },
    isDesktopDevice: function () {
        return false;
    },
});
function DetectProviderBase(props) {
    var _a = React.useState(props.userAgent), userAgent = _a[0], setUserAgentValue = _a[1];
    var isMobile = React.useState(props.isMobile)[0];
    var isTablet = React.useState(props.isTablet)[0];
    var isDesktop = React.useState(props.isDesktop)[0];
    var setUserAgent = function (val) {
        setUserAgentValue(val);
    };
    var isMobileDevice = function () {
        return isMobile;
    };
    var isTabletDevice = function () {
        return isTablet;
    };
    var isDesktopDevice = function () {
        return isDesktop;
    };
    return (React.createElement(exports.DetectContext.Provider, { value: {
            userAgent: userAgent,
            isMobile: isMobile,
            isTablet: isTablet,
            isDesktop: isDesktop,
            setUserAgent: setUserAgent,
            isMobileDevice: isMobileDevice,
            isTabletDevice: isTabletDevice,
            isDesktopDevice: isDesktopDevice,
        } }, props.children));
}
function DetectProvider(props) {
    var ua = '';
    var isMobileDevice = false;
    var isTabletDevice = false;
    var isDesktopDevice = false;
    function handleResize() {
        isMobileDevice = (0, DeviceDetect_1.isMobile)();
        isTabletDevice = (0, DeviceDetect_1.isTablet)();
        isDesktopDevice = (0, DeviceDetect_1.isDesktop)();
    }
    React.useEffect(function () {
        if (window && window.navigator && window.navigator.userAgent) {
            ua = window.navigator.userAgent;
        }
        if (window) {
            handleResize();
            window.addEventListener('resize', handleResize);
            return function () {
                if (window) {
                    window.removeEventListener('resize', handleResize);
                }
            };
        }
    }, []);
    return (React.createElement(DetectProviderBase, { userAgent: ua, isMobile: isMobileDevice, isDesktop: isDesktopDevice, isTablet: isTabletDevice }, props.children));
}
exports.DetectProvider = DetectProvider;
